module.exports = __webpack_public_path__ + "img/2_1-residenziale-biblioteca-0.2744e16c.png";